import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";

import cn from "classnames";

import React from "react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";
import { SwarovskiLink } from "../../../components/_shared-components/ui-elements/SwarovskiLink";
import { ecommerceTrackingAspect } from "../../../domain/google-tag-manager/ecommerce-tracking-aspect";
import { PLPTile } from "./ProductListingPageFilter";
import styled from "@emotion/styled";
import { createJpgLink } from "../../../components/_shared-components/image-related/createJpgAndWebpLinks";
import { PLPContent } from "./PLPContent";

export const PLPCard: ReactTFC<{
  asset?: string;
  backgroundUrl?: string;
  action: PLPTile["action"];
  headline: string;
  isNew: boolean;
  subheadlines: Array<{ name: string; isNew: boolean }>;
  text?: string;
}> = props => {
  const content = (
    <PLPContent headline={props.headline} isNew={props.isNew} subheadlines={props.subheadlines} asset={props.asset} />
  );

  const transformedBackgroundImage = props.backgroundUrl ? createJpgLink(props.backgroundUrl, 600) : undefined;

  return (
    <StyledCardLi
      onClick={props.action.tag === "click" ? props.action.onClick : undefined}
      className={cn(props.backgroundUrl ? "with-image" : undefined, props.action.tag === "link" ? "product" : "family")}
      backgroundUrl={transformedBackgroundImage}
    >
      {props.action.tag === "link" ? (
        <SwarovskiLink
          scrollToTop={true}
          isInternal={true}
          styled={"no-decoration"}
          link={props.action.href}
          attachStyles={css`
            display: grid;
            grid-template-rows: 2fr auto auto auto;
          `}
          onClick={() => {
            if (props.action.tag === "link" && props.action.metadata) {
              ecommerceTrackingAspect.productClick(props.action.metadata).push();
            }
          }}
        >
          {content}
        </SwarovskiLink>
      ) : (
        content
      )}
    </StyledCardLi>
  );
};

const gridStyles = css`
  display: grid;
  grid-template-rows: 2fr auto auto auto;

  padding: 18px;
  ${CSS_MQ.atLeastMd} {
    padding: 25px 30px;
  }

  --primary-text-color: ${CSS_COLORS.Green};
  --secondary-text-color: ${CSS_COLORS.Black};

  &.with-image {
    @media (pointer: fine) {
      &:hover {
        --primary-text-color: ${CSS_COLORS.White};
        --secondary-text-color: ${CSS_COLORS.White};

        &:before {
          content: "";
          position: absolute;

          width: 100%;
          height: 50%;

          left: 0;
          bottom: 0;

          background: linear-gradient(transparent, ${CSS_COLORS.BlackTransparent60});
          border-radius: inherit;

          z-index: 1;
        }

        background-position: center;
        background-size: cover;

        img {
          filter: opacity(0);
        }

        > * {
          z-index: 1;
        }
      }
    }
  }
`;

const cardWrapperStyles = css`
  border: 1px solid ${CSS_COLORS.Grey4};
  border-radius: 8px;

  position: relative;
  cursor: pointer;
`;

const StyledCardLi = styled.li<{ backgroundUrl: string | undefined }>`
  ${cardWrapperStyles};
  ${gridStyles};

  position: relative;
  &.with-image {
    @media (pointer: fine) {
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 8px;

        background-image: ${props => (props.backgroundUrl ? `url(${props.backgroundUrl})` : undefined)};
        background-position: center;
        background-size: cover;

        visibility: hidden;
        filter: opacity(0);

        transition: filter 0.3s;
      }

      &:hover {
        &.with-image {
          &:after {
            visibility: visible;
            filter: opacity(1);
          }
        }

        ._picture {
          > * {
            display: none;
          }
        }
      }
    }
  }
`;
